module.exports = __webpack_public_path__ + "img/lectione-1789-pagina-de-titlu-big.53f7a36d.jpg";